import React, {
  useContext,
} from 'react';
import {
  ThemeContext,
} from 'styled-components';

import {
  SVG,
} from 'web-styled';


type Props = {
  width?: string,
  height?: string,
  inactive: boolean,
  resourceType?: string,
}

const EntityIcon = ({
  width,
  height,
  inactive,
  resourceType,
}: Props) => {
  const theme = useContext(ThemeContext);
  switch (resourceType) {
    case 'workouts':
    case 'workout_templates':
    case 'workoutTemplates':
    case 'personalWorkouts':
      return (
        <SVG.KettleBell
          width={width}
          height={height}
          stroke={inactive ? '#858585' : theme.colors.link}
        />
      );
    case 'programs':
    case 'programTemplates':
    case 'program_templates':
    case 'personalPrograms':
      return (
        <SVG.Program
          width={width}
          height={height}
          stroke={inactive ? '#858585' : theme.colors.link}
        />
      );
    case 'warmups':
    case 'personalWarmups':
      return (
        <SVG.Warmup
          width={width}
          height={height}
          fill={inactive ? '#858585' : theme.colors.link}
        />
      );
    case 'cooldowns':
    case 'personalCooldowns':
      return (
        <SVG.Cooldown
          width={width}
          height={height}
          stroke={inactive ? '#858585' : theme.colors.link}
        />
      );
    case 'documents':
      return (
        <SVG.Document
          width={width}
          height={height}
          stroke={inactive ? '#858585' : theme.colors.link}
        />
      );
    default:
      return (
        <SVG.Exercise
          width={width}
          height={height}
          stroke={inactive ? '#858585' : theme.colors.link}
        />
      );
  }
};

EntityIcon.defaultProps = {
  resourceType: null,
  width: '18px',
  height: '18px',
};

export default EntityIcon;
